import _ from "underscore";

export function successGET(deferred, data){
  deferred.resolve(data);
}

export function successStoreGET(deferred, store, data){
  console.log("success func called");
  console.log(...arguments);
  store.normalizeAndStoreData(data);
  deferred.resolve(...arguments);
}

export function errorStoreGET(deferred, store, xhr, status){
  console.log("ajax error GET quotes, status:", status);
  const args = argsExceptFirst(...arguments);
  deferred.reject(args);
}


function argsExceptFirst(){
  return Array.prototype.slice.call(arguments, 1);
}


// WEBPACK FOOTER //
// ./src/actions/utilities.js